module.exports = __webpack_public_path__ + "static/media/Final Book_001.aba8ba61.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/books/Final Book_001.jpg
// module id = 1344
// module chunks = 1